import { c as _c } from "react/compiler-runtime";
import type { ProfileActivityLogBanner1Edit, ProfileActivityLogBanner2Edit } from "@/entities/IProfile";
import { ProfileActivityLogType } from "@/types/enums";
import ProfileActivityLogItemAction from "./utils/ProfileActivityLogItemAction";
const TITLE: Record<ProfileActivityLogType.BANNER_1_EDIT | ProfileActivityLogType.BANNER_2_EDIT, string> = {
  [ProfileActivityLogType.BANNER_1_EDIT]: "Banner 1",
  [ProfileActivityLogType.BANNER_2_EDIT]: "Banner 2"
};
export default function ProfileActivityLogBanner(t0) {
  const $ = _c(14);
  const {
    log
  } = t0;
  const isAdded = !log.contents.old_value;
  const t1 = isAdded ? "added" : "changed";
  let t2;
  if ($[0] !== t1) {
    t2 = <ProfileActivityLogItemAction action={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = TITLE[log.type];
  let t4;
  if ($[2] !== t3) {
    t4 = <span className="tw-whitespace-nowrap tw-text-sm lg:tw-text-base tw-font-medium tw-text-iron-300">{t3}</span>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== isAdded || $[5] !== log.contents.old_value) {
    t5 = !isAdded && <><span className="tw-h-4 tw-w-4 tw-whitespace-nowrap tw-rounded-sm tw-text-sm tw-font-medium" style={{
        backgroundColor: log.contents.old_value
      }} /><svg className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-iron-300" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="currentcOLOR" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></>;
    $[4] = isAdded;
    $[5] = log.contents.old_value;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== log.contents.new_value) {
    t6 = <span className="tw-h-4 tw-w-4 tw-whitespace-nowrap tw-rounded-sm tw-text-sm tw-font-medium" style={{
      backgroundColor: log.contents.new_value
    }} />;
    $[7] = log.contents.new_value;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t2 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <>{t2}{t4}{t5}{t6}</>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}